export default {
  TableHeadDomainPool: [
    [
      {
        displayName: 'domain_pool.domain_pool_table_head.number',
      },
      {
        displayName: 'domain_pool.domain_pool_table_head.type',
      },
      {
        displayName: 'domain_pool.domain_pool_table_head.url',
      },
      {
        displayName: 'domain_pool.domain_pool_table_head.created_date',
      },
      {
        displayName: 'domain_pool.domain_pool_table_head.status',
      },
    ],
  ],
};
